import React, { useMemo, useCallback, useEffect } from 'react';
import MapToComponents from 'react-map-to-components';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var mapObj = function mapObj(fn, obj) {
  var keys = Object.keys(obj);
  var result = {};

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];

    var _fn = fn([key, obj[key]]),
        _fn2 = _slicedToArray(_fn, 2),
        newKey = _fn2[0],
        newVal = _fn2[1];

    result[newKey] = newVal;
  }

  return result;
};

var DefaultComponent = function DefaultComponent(_ref) {
  var type = _ref.type;
  useEffect(function () {
    console.warn('Missing mapping for slice: ', type);
  }, [type]);
  return process.env.NODE_ENV === 'development' && React.createElement("div", {
    style: {
      backgroundColor: '#E53E3E',
      fontSize: '1rem',
      color: '#fff',
      textAlign: 'center',
      padding: '2rem'
    }
  }, "Missing mapping for slice: ", type);
};

var MapSlicesToComponents = React.memo(function (_ref2) {
  var componentsMap = _ref2.map,
      mapOverrides = _ref2.mapOverrides,
      listRaw = _ref2.list,
      listMiddlewareRaw = _ref2.listMiddleware,
      props = _objectWithoutProperties(_ref2, ["map", "mapOverrides", "list", "listMiddleware"]);

  // Returns an object containing the merged mapping of the the original page
  // map and the mapOverrides that is defined in any page level component.  If
  // an override exists for a slice, the new merged map will return the
  // overriden component (as a function)
  var mergedMap = useMemo(function () {
    return mapObj(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          sliceType = _ref4[0],
          Comp = _ref4[1];

      if (mapOverrides && mapOverrides.hasOwnProperty(sliceType)) return [sliceType, mapOverrides[sliceType](Comp)];
      return [sliceType, Comp];
    }, componentsMap);
  }, [componentsMap, mapOverrides]);
  var getKey = useCallback(function (x) {
    return x.id;
  }, []);
  var getType = useCallback(function (x) {
    return (x.__typename || '').replace(/^Prismic/, '');
  }, []);
  var listMiddleware = useCallback(listMiddlewareRaw || function (x) {
    return x;
  }, [listMiddlewareRaw]);
  var list = useMemo(function () {
    return listMiddleware(listRaw);
  }, [listRaw, listMiddleware]);
  return React.createElement(MapToComponents, _extends({
    getKey: getKey,
    getType: getType,
    "default": DefaultComponent,
    defaultMapDataToProps: function defaultMapDataToProps(_ref5) {
      var type = _ref5.type;
      return {
        type: type
      };
    },
    list: list,
    map: mergedMap
  }, props));
});

export default MapSlicesToComponents;
